import SearchPartial from './components/domain/SearchPartial.vue';
import DomainResults from './components/domain/DomainResults.vue';
import HostingPartial from './components/hosting/HostingPartial.vue';
import SslPartial from './components/ssl/SslPartial.vue';
import VpsPartial from './components/vps/VpsPartial.vue';
import OrderOverview from './components/order-full/OrderOverview.vue';
import SingleServiceOverview from './components/order-service/OrderOverview.vue';
import validationMixin from './mixins/validation.js';
import PaymentApi from './services/api/payment.js';
import ProductsApi from './services/api/product.js';
import orderPageMixin from './mixins/order-page.js';
import paymentMixin from './mixins/payment';
import productMixin from './mixins/product';
import productsMixin from './mixins/products';
import singleServiceMixin from './mixins/single-service.js';
import supportMixin from './mixins/support';
import trackingMixin from './mixins/tracking.js';

export {
    SearchPartial,
    DomainResults,
    HostingPartial,
    OrderOverview,
    SslPartial,
    VpsPartial,
    SingleServiceOverview,
    PaymentApi,
    ProductsApi,
    orderPageMixin,
    paymentMixin,
    productMixin,
    productsMixin,
    singleServiceMixin,
    supportMixin,
    trackingMixin,
    validationMixin
};
